<template>
    <div>
        <div style="border-bottom: 1px solid #e4e3e4">
            <h1>订单列表</h1>
        </div>
        <div>
            <DateFilter
                :currDate.sync="currDate"
                :dateRange.sync="dateRange"
                :vip.sync="vip"
                :searchType.sync="searchType"
                :handleClick="getOrderList"
            ></DateFilter>
        </div>
        <OrderList-OrderList
            v-loading="loading"
            :orderList="orderList"
            :ddly.sync="ddly"
            :psfs.sync="psfs"
            :ddzt.sync="ddzt"
            :getOrderList="getOrderList"
            :totalPage="totalPage"
            :currPage="currPage"
        ></OrderList-OrderList>
    </div>
</template>

<style lang="less" scoped>

</style>

<script>
    import OrderCon from '../components/OrderControl/OrderList';
    import OrderList from '../components/OrderList';
    import DateFilter from '../components/Common/DateFilter.vue';
    import Vue from 'vue';
    import { orderList, orderSuccess} from '../stores/api';

    Vue.component('OrderList-Header', OrderList.Header);
    Vue.component('DateFilter', DateFilter);
    Vue.component('OrderList-OrderList', OrderCon);
    export default {
        data () {
            return {
                loading: false,
                orderList: [],
                status_count: [],
                currStatus: '',
                currReferer: '',
                currDate: '',
                dateRange: null,
                currPage: 1,
                totalPage: 1,
                keyword: '',
                vip: '',
                searchType: '',
                ddly: '',
                psfs: '',
                ddzt: '0,1',
            };
        },
        beforeMount () {
            this.getOrderList();
        },
        create() {
            // console.log()
        },
        methods: {
            getOrderList (pamars) {
                console.log(this.ddly+this.psfs+this.ddzt)
                this.loading = true;
                let temp = {};
                if (this.ddzt !== '') {
                    if (this.ddzt === '4') {
                        temp.tax = 1
                    } else {
                        temp.yuyue_state = this.ddzt
                    }
                }
                if (this.ddly !== '') {
                    temp.referer = this.ddly
                }
                if (this.psfs !== '') {
                    temp.delivery_method = this.psfs
                }
                if (this.vip !== '') {
                    temp.searchkey = this.vip;
                }

                if (this.searchType !== '') {
                    temp.searchType = this.searchType;
                }
                // if (this.currStatus !== '') {
                //     temp.status = this.currStatus;
                // }
                if (this.currDate !== '') {
                    temp.typetime = this.currDate;
                } else if (this.dateRange) {
                    temp.starttime = Date.parse(this.dateRange[0]) / 1000;
                    temp.endtime = Date.parse(this.dateRange[1]) / 1000 + 24 * 60 * 60;
                }
                if (pamars) {
                    temp.page = pamars.page;
                }
                orderSuccess(temp).then(res => {
                    console.log(res.data.data)
                    this.orderList = res.data.data;
                    if (res.data.data) {
                        this.orderList.forEach((item) => {
                            if (item.goods_list) {
                                item.goods_list.forEach((it) => {
                                    it['referer'] = item.referer
                                    it['order_id'] = item.order_id
                                    // it.push({referer:item.referer})
                                })
                            }
                        })
                    }
                    this.status_count = res.data.status_count;
                    this.currPage = Number(res.data.page);
                    this.totalPage = Number(res.data.pagecount);
                    if (this.currStatus === '') {
                        this.currStatus = res.data.status_count[0].status;
                    }
                    if (this.currReferer === '') {
                        this.currReferer = ''
                    }
                    this.loading = false;
                });
            },
        },
        watch: {
            currStatus (val, old) {
                if (old !== '') {
                    this.getOrderList();
                }
            },
            currReferer (val, old) {
                if (old !== '') {
                    this.getOrderList();
                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/router/OrderList2.vue